// import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
// import scrollToElement from "scroll-to-element";
// import tick from "../helpers/async";
// import wait from '../helpers/wait';
// const ResizeObserver = window.ResizeObserver || Polyfill;
import { setCSSCustomProperty } from "../helpers/css";

const isPage = slug => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMeasurementCheckers();
        this.recordNavBarHeight();
        this.initTimeLineSlideMain();
        this.initforHeaderMenubar(); 
        // this.initForewordSlider();
        
        if (isPage('home')) {
          // this.initHomepageForewordSection();
          this.initscrolltoptobottum();
          this.inithomePageslider();
          this.initHomepageContentSlides();
          // this.initHomepageForewordSection();
        }
        this.initForewordSection();
        this.initMobviewmenuforOffsetPage();
        this.initanimationForallPage();
        this.initcounterforAllslide();
        this.initBlogslider();
        this.initTabforAllpage();
        this.initGroupLogoforpages();

        resolve();
      } catch (error) {
        reject(error);
      }
    })
  },

  initForewordSection() {
    const forewordSection = document.getElementById('forewordSectionPopupWrapper');
    const closeButton = document.getElementById('closeForeword');
    const forewordLink = document.getElementById('forewordLink');
    // console.log(forewordSection);
   
    if(forewordSection) {
      // forewordSection.classList.toggle('sectionHidden');
      // document.documentElement.classList.toggle('forewordSection-open');

      closeButton.addEventListener('click', () => addHiddenClass());
      // forewordSection.addEventListener('click', () => addHiddenClass());
    }

    if(forewordLink) {
      forewordLink.addEventListener('click', () => addHiddenClass())
    }

    const addHiddenClass = () => {
      // console.log('click');
      forewordSection.classList.toggle('sectionHidden');
      document.documentElement.classList.toggle('forewordSection-open');
    }
  },

  initHomepageForewordSection() {
    const forewordSection = document.getElementById('forewordSectionPopupWrapper');
    const closeButton = document.getElementById('closeForeword');
    const forewordLink = document.getElementById('forewordLink');
    // console.log(forewordSection);
   
    if(forewordSection) {
      forewordSection.classList.toggle('sectionHidden');
      document.documentElement.classList.toggle('forewordSection-open');

      // closeButton.addEventListener('click', () => addHiddenClass());
      // forewordSection.addEventListener('click', () => addHiddenClass());
    }

    // if(forewordLink) {
    //   forewordLink.addEventListener('click', () => addHiddenClass())
    // }

    // const addHiddenClass = () => {
    //   // console.log('click');
    //   forewordSection.classList.toggle('sectionHidden');
    //   document.documentElement.classList.toggle('forewordSection-open');
    // }
    
  },

  initHomepageContentSlides() {
    const contentThumbsSlides = new Swiper('.contentSlidesThumbsSwiper', {
      loop: true,
      slidesPerView: 6,
      allowTouchMove: false,
    })
    const contentSlides = new Swiper('.contentSlidesSwiper',  {
      loop: true,
      autoHeight: true,
      navigation: {
        enabled: true,
        nextEl: ".contentSlidesSwiper .swiper-button-next",
        prevEl: ".contentSlidesSwiper .swiper-button-prev"
      },
      thumbs: {
        swiper: contentThumbsSlides,
      }
    });
    // contentSlides.controller.control = contentThumbsSlides;
    // contentThumbsSlides.controller.control = contentSlides;

  },

  recordWpAdminBarHeight() {
    const el = document.getElementById('wpadminbar');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
    return height;
  },
  
  recordNavBarHeight() {
    const el = document.querySelector('.nav');
    // const el = document.querySelector('.section-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--nav-height', height + 'px');
    return height;
  },

  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.equalheight('.equal_Title');
      this.equalheight('.equal_Content');
      this.equalheight('.equal_height');
      this.wrapperPadding();
      this.recordWpAdminBarHeight();
      // this.recordNavBarHeight();
      // this.recordNavSearchBarHeight();
    }
    const handleWindowResize = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.equalheight('.equal_Title');
      this.equalheight('.equal_Content');
      this.equalheight('.equal_height');
      this.wrapperPadding();
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      // this.recordNavSearchBarHeight();
    }
    window.addEventListener('load', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
    window.addEventListener('load', AOS.refresh);
  },
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },

  getSiteTitle() {
    return document.body.getAttribute('data-site-title');
  },

  getPageTitle() {
    const titleEl = document.querySelector('.page-header__title') || document.querySelector('h1') || document.querySelector('title');
    const title = titleEl && titleEl.innerText;
    return title || '';
  },

  initPostGridSwiper() {

    const grid = document.querySelector('.post-grid');
    if (!grid) return;
    const postItems = grid.querySelectorAll('.post-item');

    const container = document.createElement('div');
    container.classList.add('post-grid-swiper');
    container.classList.add('swiper-container');

    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');

    const slides = Array.from(postItems).map(postItem => {
      const slideContainer = document.createElement('div');
      slideContainer.classList.add('swiper-slide');
      slideContainer.append(postItem);
      return slideContainer;
    });

    wrapper.append(...slides);
    container.append(wrapper);
    grid.replaceWith(container);

  },
  detectRatio(el) {
    if (!el) return;
    const w = el.clientWidth;
    const h = el.clientHeight;
    const ratio = w / h;
    const orientation = ratio >= 1 ? 'landscape' : 'portrait';
    el.setAttribute('data-element-width', w + 'px');
    el.setAttribute('data-element-height', h + 'px');
    el.setAttribute('data-element-ratio', ratio);
    el.setAttribute('data-element-orientation', orientation);
    setCSSCustomProperty('--element-width', w + 'px', el);
    setCSSCustomProperty('--element-height', h + 'px', el);
    setCSSCustomProperty('--element-ratio', ratio, el);
    setCSSCustomProperty('--element-orientation', orientation, el);
  },

  initRatioWatcher() {
    const els = document.querySelectorAll('[data-watch-ratio]');
    Array.from(els).forEach(el => {
      const handler = () => this.detectRatio(el);
      window.addEventListener('load', handler);
      window.addEventListener('resize', handler);
    });
  },
  initVideoCoverer() {
    const handler = () => {
      const videoSlides = document.querySelectorAll('.section-hero-banner');
      Array.from(videoSlides).forEach(slide => {
        const video = slide.querySelector('video');
        const checkVideoRatio = () => {
          const videoWidth = video.videoWidth;
          const videoHeight = video.videoHeight;
          const videoRatio = videoWidth / videoHeight;
          const containerWidth = slide.clientWidth;
          const containerHeight = slide.clientHeight;
          const containerRatio = containerWidth / containerHeight;
          if (videoRatio >= containerRatio) {
            // video is wider or square; 100% height and auto width.
            video.setAttribute('data-fill-mode', 'fill-height');
          } else {
            video.setAttribute('data-fill-mode', 'fill-width');
          }
        };
        checkVideoRatio();
      })
    }
    window.addEventListener('load', handler);
    window.addEventListener('resize', handler);
  },

  initforHeaderMenubar() {
    this.equalheight('.equal_Title');
    this.equalheight('.equal_Content');
    this.equalheight('.equal_height');

    $('.menubar .navbar').before('<a class="expandMenu"><i></i><i></i><i></i></a>');
    $('.menubar .dropdown-mob').before('<span class="childExpand"><i></i><i></i></span>');
    // $('.menubar .MegaMenuInner').before('<span class="childExpand"><i></i><i></i></span>');
    $(document).on("click", ".expandMenu", function () {
      $(this).toggleClass("active").next().slideToggle(250)

    });
    // $(".hs-item-has-children > a ").attr("href", "javascript:(0);");
    $(document).on("click", ".childExpand", function () {
      $(this).parent().siblings(".childmenu-Mob").find(".childExpand").removeClass("open");
      $(this).parent().siblings(".childmenu-Mob").find(".dropdown-mob").slideUp(250);
      $(this).next(".dropdown-mob").slideToggle(250);
      $(this).toggleClass("open");
      // console.log('test');
      $(document).toggleClass("menu-open");
      return false
    });


    var windowWidth = $(window).width();
    if (windowWidth < 992){
      // for a tag
      $(document).on("click", ".navbar ul li.childmenu-Mob>a", function () {
        $(this).parent().siblings(".childmenu-Mob").find(".childExpand").removeClass("open");
        $(this).parent().siblings(".childmenu-Mob").find(".dropdown-mob").slideUp(250);
        $(this).next('.childExpand').next(".dropdown-mob").slideToggle(250);
        $(this).next('.childExpand').toggleClass("open");
        // console.log('test');
        $(document).toggleClass("menu-open");
        return false
      });
      
        // other menu for a tag
      $(document).on("click", ".V2navbar ul li.menu-item-has-children>a", function () {
        $(this).parent().siblings(".V2-dropdown-menu").find(".V2childExpand").removeClass("open");
        $(this).parent().siblings(".V2-dropdown-menu").find(".V2-dropdown-menu").slideUp(250);
        $(this).next('.V2childExpand').next(".V2-dropdown-menu").slideToggle(250);
        $(this).next('.V2childExpand').toggleClass("open");
        console.log('test');
        // $(document).toggleClass("open");
        return false
      });
    }
    // other menu for a tag
    if (windowWidth > 991) {
      $(document).on("click", ".Megachildmenu > a", function () {
        // console.log('2222');
        $(this).parent().siblings('li').find("a").removeClass("open");
        $(this).parent().siblings(".childmenu").find(".dropdown-menu-icon").slideUp(250);
        $(this).parent().find(".dropdown-menu-icon").slideToggle(250);
        $(this).toggleClass("open");
        // console.log('test');
        if(!document.documentElement.classList.contains('megamenu-open')) {
          document.documentElement.classList.add('megamenu-open');
        }else {
          document.documentElement.classList.remove('megamenu-open');
        }
        return false
      });

      $(document).on("click", ".item-has-children > a", function () {
        $(this).parent().siblings(".item-has-children").find("a").removeClass("open");
        $(this).parent().siblings(".item-has-children").find(".dropdown-menu-icon-Inner").slideUp(250);
        $(this).parent().find(".dropdown-menu-icon-Inner").slideToggle(250);
        $(this).toggleClass("open");
        // console.log('test');
        return false
      });

      $(document).on("click", ".child-item-has-children > a", function () {
        $(this).parent().siblings(".child-item-has-children").find("a").removeClass("open");
        $(this).parent().siblings(".child-item-has-children").find(".child-dropdown-menu-icon-Inner").slideUp(250);
        $(this).parent().find(".child-dropdown-menu-icon-Inner").slideToggle(250);
        $(this).toggleClass("open");
        return false
      });

      $(document).on("click", ".CloseIcon", function () {
        if(document.documentElement.classList.contains('megamenu-open')) {
          document.documentElement.classList.remove('megamenu-open');
        }
        $(this).closest(".childmenu").find("a").removeClass("open");
        $(this).closest(".childmenu").find(".childExpand").removeClass("open");
        $(this).closest(".Mega-dropdown-menu").slideUp(250);
      });
    }
  },
  initscrolltoptobottum() {
    $(".AngleImgTxt a").click(function () {
      $('html, body').animate({
        scrollTop: $(".IconTitleSection").offset().top - 75
        // scrollTop: $(".forewordSection").offset().top - 75
      }, 2000);
    });
  },
  initanimationForallPage() {
    Animation
    AOS.init({
      offset: 100,
      duration: 1500,
      delay: 100,
      once: true
    });
  },
  inithomePageslider() {
    const thumbsSlides = new Swiper('.counterThumbsSlides', {
      loop: true,
      slidesPerView: 4,
      allowTouchMove: false,
    })
    const mainSlides = new Swiper(".mySwiperCounterSlider", {
      loop: true,
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: false,
      autoHeight: true,
      navigation: {
        enabled: true,
        nextEl: ".mySwiperCounterSlider .swiper-button-next",
        prevEl: ".mySwiperCounterSlider .swiper-button-prev",
      },
      thumbs: {
        swiper: thumbsSlides,
      }
    });

  },

  initcounterforAllslide() {
    var counted = 0;
    $(window).on('scroll', function () {

      var oTop = $('#counterTop')?.offset()?.top - window.innerHeight;
      if (counted == 0 && $(window).scrollTop() > oTop) {
        $('.count').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate({
            countNum: countTo
          },

            {

              duration: 2000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }

            });
        });
        counted = 1;
      }

    });
    var countedV4 = 0;
    $(window).on('scroll', function () {

      var oTop = $('#counterTopV4')?.offset()?.top - window.innerHeight;
      if (countedV4 == 0 && $(window).scrollTop() > oTop) {
        $('.countV4').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate({
            countNum: countTo
          },

            {

              duration: 2000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }

            });
        });
        countedV4 = 1;
      }

    });

    // Counter Inner
    var countedV2 = 0;
    $(window).on('scroll', function () {

      var oTop = $('#counterTopV2')?.offset()?.top - window.innerHeight;
      if (countedV2 == 0 && $(window).scrollTop() > oTop) {
        $('.count').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate({
            countNum: countTo
          },

            {

              duration: 2000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }

            });
        });
        countedV2 = 1;
      }

    });

    // Counter Two Column
    var countedV2New = 0;
    $(window).on('scroll', function () {

      var oTop = $('#counterTopV2New')?.offset()?.top - window.innerHeight;
      if (countedV2New == 0 && $(window).scrollTop() > oTop) {
        $('.count').each(function () {
          var $this = $(this),
            countTo = $this.attr('data-count');
          $({
            countNum: $this.text()
          }).animate({
            countNum: countTo
          },

            {
              duration: 2000,
              easing: 'swing',
              step: function () {
                $this.text(Math.floor(this.countNum));
              },
              complete: function () {
                $this.text(this.countNum);
                //alert('finished');
              }

            });
        });
        countedV2New = 1;
      }

    });
  },
  initBlogslider() {
    const SwiperBlogSlider = new Swiper(".SwiperBlogSlider", {
      slidesPerView: 1.5,
      spaceBetween: 48,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      navigation: {
        nextEl: ".SwiperBlogSlider .swiper-button-next",
        prevEl: ".SwiperBlogSlider .swiper-button-prev"
      },
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2.47
        }
      }
    });
  },

  initForewordSlider() {
    const forewordSectionSwiper = new Swiper('.forewordSectionSwiper',  {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      // autoplay: true,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: true,
      // },
      navigation: {
        nextEl: ".forewordSectionSwiper .swiper-button-next",
        prevEl: ".forewordSectionSwiper .swiper-button-prev"
      }
    })
  },

  initHomepageContentSlider() {
    const CountSlideRepeater = new Swiper('.CountSlideRepeater',  {
      autoplay: true,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".CountSlideRepeater .swiper-button-next",
        prevEl: ".CountSlideRepeater .swiper-button-prev"
      },
    })
  },

  initTimeLineSlideMain() {
    const TimeLineSlideMain = new Swiper(".TimeLineSlideMain", {
      slidesPerView: 1,
      autoplay: true,
      spaceBetween: 30,
      freeMode: true,
      // grabCursor: true,
      loop: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true
      },
      navigation: {
        nextEl: ".TimeLineSlideMain .swiper-button-next",
        prevEl: ".TimeLineSlideMain .swiper-button-prev"
      },
      breakpoints: {
        481: {
          slidesPerView: 3.5,
          spaceBetween: 30
        },
      }
    });
  },
  initTabforAllpage() {

    $(".tabsV2").on("click", ".tabV2", function (e) {
      e.preventDefault();
      $(".tabV2").removeClass("activeV2");
      $(".showcontentV2").removeClass("showV2");
      $(this).addClass("activeV2");
      $($(this).attr("href")).addClass("showV2");
      $(this).closest('.tabsV2').find('.expandTabbV2').removeClass('changeV2');

      if ($(window).width() < 768) {
        var tabText = $(".tabV2.activeV2").text();
        $('.expandTabbV2').text(tabText);
      }

    });

    if ($(window).width() < 768) {
      $(".tabPV2 .showcontentV2:nth-child(2)").addClass("showV2");
      $('.expandTabbV2').on('click', function () {
        $(this).next().slideToggle();
        $(this).toggleClass('changeV2');

      });
      $('.tabV2').on('click', function () {
        $(this).parents('.tabsToggleV2').slideUp();

      })
    }
    // 
    $(".tabs").on("click", ".tab", function (e) {
      e.preventDefault();
      $(".tab").removeClass("active");
      $(".showcontent").removeClass("show").fadeOut(1000);
      $(this).addClass("active");
      $($(this).attr("href")).addClass("show").fadeIn(1000);
      $(this).closest('.tabs').find('.expandTabb').removeClass('change');

      if ($(window).width() < 768) {
        var tabText = $(".tab.active").text();
        $('.expandTabb').text(tabText);
      }

    });

    if ($(window).width() < 768) {
      $(".tabP .showcontent:first-child").addClass("show");
      $('.expandTabb').on('click', function () {
        $(this).next().slideToggle();
        $(this).toggleClass('change');

      });
      $('.tab').on('click', function () {
        $(this).parents('.tabsToggle').slideUp();

      })
    }
  },

  initGroupLogoforpages() {
    $('.GrpILogoParent').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      responsive: [{
        breakpoint: 767,
        settings: {
          slidesToShow: 6
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 4
        }
      }]
    });
  },
  initMobviewmenuforOffsetPage() {
    $('.V2MenuParent .V2navbar').before('<a class="V2expandMenu"><i></i><i></i><i></i></a>');
    $('.V2MenuParent .V2-dropdown-menu').before('<span class="V2childExpand"><i></i><i></i></span>');
    $(document).on("click", ".V2expandMenu", function () {
      $(this).toggleClass("active").next().slideToggle(250)

    });
    $(document).on("click", ".V2childExpand", function () {
      $(this).parent().siblings(".V2childmenu").find(".V2childExpand").removeClass("open");
      $(this).parent().siblings(".childmenu").find(".V2-dropdown-menu").slideUp(250);
      $(this).next(".V2-dropdown-menu").slideToggle(250);
      $(this).toggleClass("open");
      return false
    });
  },

  equalheight(container) {
    var currentTallest = 0, currentRowStart = 0, rowDivs = new Array(), $el, topPosition = 0;
    $(container).each(function () {
      $el = $(this);
      $($el).height('auto')
      topPosition = $el.position().top;
      if (currentRowStart != topPosition) {
        for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = $el.outerHeight();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.outerHeight()) ? ($el.outerHeight()) : (currentTallest);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  },
  wrapperPadding() {
    var wW = $(window).width();
    if ($('.TimeLineSliderSection .wrapper').length > 0) { var wSize = $('.TimeLineSliderSection .wrapper').width(); } // if wrapper is available in page
    else { // if wrapper is not available in page
      if ($(window).width() > 1230) { var wSize = 1170; }
      else if ($(window).width() < 1230 && $(window).width() > 992) { var wSize = 900; }
      else { var wSize = wW; }
    }
    var iPadding = ((wW - wSize) / 2);
    if ($('.wrapLeft').length > 0) {
      $('.wrapLeft').css('padding-left', iPadding);
      $('.wrapLeft').css('padding-right', iPadding);
    }
    if ($('.wrapRight').length > 0) {
      $('.wrapRight').css('padding-right', iPadding);
      $('.wrapRight').css('padding-left', iPadding);
    }
  }
}